<button
  data-test-id="wilson-timeline-shift-form-view-button"
  [disabled]="disabled"
  (click)="navigateToShiftDetails()"
  nz-button
  nzType="default"
  class="w-100 fw-normal"
>
  <fa-icon [icon]="faUpRightFromSquare"></fa-icon>
</button>
